const ReportAndAnalyticsNonActiveIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.93414 11.333H12.0608C13.3275 11.333 13.9941 10.6663 13.9941 9.39968V1.33301H1.99414V9.39968C2.00081 10.6663 2.66748 11.333 3.93414 11.333Z"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33398 1.33301H14.6673"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33398 14.6663L8.00065 13.333V11.333"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 14.6663L8 13.333"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7.33301L7.1 5.57967C7.26666 5.43967 7.48666 5.47967 7.6 5.66634L8.4 6.99967C8.51334 7.18634 8.73334 7.21968 8.9 7.08634L11 5.33301"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReportAndAnalyticsNonActiveIcon;
